module.exports = __webpack_public_path__ + "img/894-d233a8.png";